module.exports = __webpack_public_path__ + "static/media/coin_metro.533cce33.png";